import React from "react";
import { Button, Card, Tags } from "../../ui";
import { STATE_TAG, cardAction, formatRevenue } from "./applicationsModel";

// One compact card: name + status, last month's revenue (only when there is
// report data), active / ALL store branches, and one contextual button.
export default function ApplicationCard({
  app,
  lang,
  t,
  canManage,
  canReview,
  onOpen,
}) {
  const name = lang === "ar" ? app.nameAr : app.nameEn;
  const action = cardAction(app.state, { canManage, canReview });
  const revenue = formatRevenue(app.revenue, lang);
  const statusLabel = t.status[app.state] || app.state;

  return (
    <Card
      className={`lud-application-card is-${app.state}`}
      hoverable={false}
      padding="sm"
    >
      <div className="lud-application-card-row lud-application-card-head">
        <strong className="lud-application-name" title={name}>
          {name}
        </strong>
        <Tags
          variant={STATE_TAG[app.state] || "neutral"}
          appearance="soft"
          size="sm"
        >
          {statusLabel}
        </Tags>
      </div>
      <div className="lud-application-card-row-middle">
        <div className="lud-application-card-row lud-application-branches">
          {t.branchesCount(app.activeBranches, app.totalBranches)}
        </div>
        {app.pending?.count > 0 && (
          <Tags variant="warning" appearance="soft" size="sm" className="lud-application-pending">
            {t.flow.pendingBadge(app.pending.count)}
          </Tags>
        )}
        {revenue && (
          <div
            className="lud-application-card-row lud-application-revenue"
            title={t.lastMonth}
          >
            <span className="lud-application-revenue-value">{revenue}</span>
          </div>
        )}
      </div>

      <Button
        variant={action.variant}
        appearance="soft"
        size="sm"
        fullWidth
        aria-label={`${t.action[action.label]} — ${name}`}
        onClick={() => onOpen(action.open, app)}
      >
        {t.action[action.label]}
      </Button>
    </Card>
  );
}
